import { Add } from '@mui/icons-material';
import { Box, ButtonBase, IconButton, Tooltip, useTheme } from '@mui/material';
import { FC, useState } from 'react';
import { useIntl } from 'react-intl';
import { useModalContext } from '../../modal/ModalContext';
import { useTypedPathParams } from '../../../../shared/fe/hooks/useTypedPathParams';

import { journeyDetailSchema } from '../detail/JourneyDetailPage';

type Props = Readonly<{ phaseId: string; index: number }>;

export const AddActivityDividerButton: FC<Props> = ({ phaseId, index }) => {
	const intl = useIntl();
	const [showAddActivity, setShowAddActivity] = useState<boolean>(false);
	const { setModal } = useModalContext();
	const { id } = useTypedPathParams(journeyDetailSchema);
	const theme = useTheme();

	return (
		<ButtonBase
			sx={{
				position: 'absolute',
				top: 0,
				right: -16,
				width: 30,
				height: '100%',
				opacity: showAddActivity ? 1 : 0,
				zIndex: 3,
			}}
			className={'journey__activity-divider-button'}
			onMouseEnter={() => setShowAddActivity(true)}
			onMouseLeave={() => setShowAddActivity(false)}
			onClick={() => setModal({ type: 'createActivity', payload: { journeyId: id, phaseId: phaseId, activityOffset: index.toString() } })}
		>
			<Tooltip title={intl.formatMessage({ id: 'detail.add-activity.divider' })} arrow placement={'top'}>
				<IconButton
					sx={{
						borderRadius: '100%',
						backgroundColor: (theme) => theme.palette.primary[400],
						width: 20,
						height: 20,
						top: 0,
						left: -1,
						zIndex: 1,
						'&:hover': {
							backgroundColor: (theme) => theme.palette.primary[400],
						},
					}}
				>
					<Add sx={{ width: 16, height: 16, color: (theme) => theme.palette.grey[0] }} />
				</IconButton>
			</Tooltip>
			<Box
				sx={{
					position: 'absolute',
					top: 0,
					left: 13,
					width: 2,
					height: '100%',
					border: 0,
					bgcolor: theme.palette.primary[400],
				}}
			/>
		</ButtonBase>
	);
};
